/* eslint-disable quotes */
/* eslint-disable semi */
import { storeMutations } from '@store/mutations.constants';
import licenseState from './state';

export const state = licenseState;
const mutations = {
  [storeMutations.domainMutation]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.domain = res.data.data;
    }
  },
  [storeMutations.setDomainMutation]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.domains = res.data;
    }
  },
};
export default {...mutations };